export interface ChannelTokenDefinition {
  displayName: string;
  tokens: string[];
}

export const CHANNEL_TOKEN_MAP: Record<string, ChannelTokenDefinition> = {
  email: {
    displayName: 'Email',
    tokens: ['1', 'boxsendemail', 'email'],
  },
  sms: {
    displayName: 'SMS',
    tokens: ['2', 'boxsendsms', 'sms'],
  },
  popup: {
    displayName: 'Pop-in',
    tokens: ['3', 'boxdisplayfreepopup', 'popup', 'popin', 'pop-in'],
  },
  embed: {
    displayName: 'Smart Content',
    tokens: [
      '4',
      'boxdisplayfreemodel',
      'embed',
      'smartcontent',
      'smart_content',
      'smart-content',
    ],
  },
  facebookmessenger: {
    displayName: 'Facebook Messenger',
    tokens: [
      '5',
      'boxsendfbmessenger',
      'facebookmessenger',
      'fbmessenger',
      'fb_messenger',
      'fb-messenger',
    ],
  },
  pushnotifications: {
    displayName: 'Push Notification',
    tokens: [
      '6',
      'boxsendpushnotification',
      'pushnotifications',
      'pushnotification',
      'push_notification',
      'push-notification',
    ],
  },
  whatsapp: {
    displayName: 'WhatsApp',
    tokens: ['7', 'boxsendwhatsapp', 'whatsapp'],
  },
  rcs: {
    displayName: 'RCS',
    tokens: ['8', 'boxsendrcs', 'rcs', 'richtexting', 'rich_texting', 'rich-texting'],
  },
  teaser: {
    displayName: 'Teaser',
    tokens: ['9', 'teaser'],
  },
};

const CHANNEL_TOKENS_LOOKUP: Map<string, string> = (() => {
  const map = new Map<string, string>();
  Object.entries(CHANNEL_TOKEN_MAP).forEach(([slug, definition]) => {
    definition.tokens.forEach((token) => {
      if (!token) {
        return;
      }
      map.set(token.toLowerCase(), slug);
    });
  });
  return map;
})();

export const getChannelTokens = (slug: string): string[] => {
  const definition = CHANNEL_TOKEN_MAP[slug.toLowerCase()];
  if (!definition) {
    return [];
  }

  const unique = new Set<string>();
  definition.tokens.forEach((token) => {
    const trimmed = token.trim();
    if (trimmed) {
      unique.add(trimmed);
    }
  });

  return Array.from(unique);
};

export const getChannelDisplayName = (slug: string): string | undefined => {
  const definition = CHANNEL_TOKEN_MAP[slug.toLowerCase()];
  return definition?.displayName;
};

export const resolveChannelSlugFromToken = (token: string): string | undefined => {
  if (!token) {
    return undefined;
  }

  return CHANNEL_TOKENS_LOOKUP.get(token.trim().toLowerCase());
};
